<template>
  <div class="basic-block block-about-fortune2-base" :style="styles">
    <div class="content-wrap">
      <div class="block-about-fortune2-base__inner">
        <!-- 占術紹介 -->
        <!-- <lp-title title="占術紹介" :color-scheme="colorScheme" alphabet="fortune-telling" />
        <h3 class="block-about-fortune-base__headline">{{ targetInfo.fortune.headline }}</h3>
        <p class="block-about-fortune-base__text" v-html="targetInfo.fortune.text"></p> -->
        <!-- 誕生日からわかる・・・ -->
        <div class="block-about-fortune2-base__box">
          <!-- 属性開抛で見るあなたのこと -->
          <!-- <img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44">
          <h3 class="block-about-fortune-base__you-headline" v-html="targetInfo.fortune.you.headline"></h3>
          <p class="block-about-fortune-base__you-text" v-html="targetInfo.fortune.you.text"></p>
          <div class="block-about-fortune-base__you-counselor">
            <p class="block-about-fortune-base__you-comment" v-html="targetInfo.fortune.you.comment"></p>
            <img class="block-about-fortune-base__you-counselor-image" :src="targetInfo.fortune.you.counselorImage" alt="">
          </div> -->
          
          <p class="top-text">あのタレントや芸能人も驚いた<br>
              <span class="gold-line">人の可能性を極限化</span>する<br>
              斗弥の属性開抛とタロットが<br>
              <span class="gold bold">月額528円で占い放題</span>
          </p>
          <!-- <p class="block-about-fortune-base__you-advice" v-html="targetInfo.fortune.you.advice"></p> -->
          <div v-for="(point, idx) in pointCount(0,1)" :key="idx" class="block-about-fortune2-base__point">
            <div class="talkarea">
              <div class="talkarea__box talkarea__box--left">
                <img :src="point.iconLeft" class="talkarea-icon">
                <p v-html="point.leftWord"></p>
              </div>
              <div class="talkarea__box talkarea__box--right">
                <img :src="point.iconRight" class="talkarea-icon">
                <p v-html="point.rightWord"></p>
              </div>
            </div>
            <p class="caption" v-html="point.caption"></p>
            <div class="title-box"><img class="title--banner" :src="point.pointTitle"></div>
            <p :class="{center : point.isCenter }" class="point-lead" v-html="point.pointLead"></p>
            <img v-if="point.mainImage" :src="point.mainImage" alt="" class="mainimage">
            <ul v-if="point.pointLists" class="point-ul">
              <li class="point-li" v-for="(item, idx) in point.pointLists" :key="idx" v-html="item"></li>
            </ul>
            <p v-if="point.popText" class="pop-text">{{point.popText}}</p>

            <lp-base-button
              :label="point.buttontext"
              design="fill"
              :color-scheme="colorScheme"
              @clicked="clickedSubscFor(point.eventLabel)"
            />

          </div>

          <div class="block-about-fortune2-base__point">
            <div class="talkarea">
              <div class="talkarea__box talkarea__box--left">
                <img src="/static/img/recommend/lp/touwa/icon_touwa.png" class="talkarea-icon">
                <p>「5月、決めなきゃいけないような出来事が」</p>
              </div>
              <div class="talkarea__box talkarea__box--right">
                <img src="/static/img/recommend/lp/touwa/icon_woman2.png" class="talkarea-icon">
                <p >「！もう全当たり」<br>藤田ニコルさん</p>
              </div>
            </div>
            <p class="caption">テレビ東京『どこまで言っていいですか？』<br>6月10日放送回より</p>
        
            <img class="mainimage" src="/static/img/recommend/lp/touwa/yourfortune_title.png" alt="">

            <ul class="point-ul point-ul--etc">
              <li class="point-li">・今、どういう運気の中にある？</li>
              <li class="point-li">・仕事を占う斗弥タロット</li>
              <li class="point-li">・自分らしく生きたいと思ったときに</li>
              <li class="point-li">・解放されるべきエネルギー</li>
              <li class="point-li">・今月の開運術</li>
            </ul>


            <img class="f_f_title" src="/static/img/recommend/lp/touwa/free_fortune_title2.svg" alt="">
            <subscr-fortune-preview
              :result-data="previewResultList[0]"
              :color-data="colorScheme"
              :lp-id="lpId"
              class="preview-item"
            />

            <img class="mainimage" src="/static/img/recommend/lp/touwa/touwa_answer.png" alt="">

            <ul class="point-ul">
              <li class="point-li">・年内<strong>なるはやで離婚</strong>したい</li>
              <li class="point-li">・<strong>今月告白したい</strong>と思ってます</li>
              <li class="point-li">・<strong>復縁希望</strong>。相手の状況はどうですか？</li>
              <li class="point-li">・今年は<strong>起業・転身</strong>に適した年ですか？</li>
              <li class="point-li">・今年、<strong>転職してお給料を上げたい</strong></li>
              <li class="point-li">・今年<strong>引っ越し</strong>したら<strong>運気は上がる</strong>？</li>
              
            </ul>
           

            <p class="pop-text">＼運勢も528円で占い放題／</p>
            <lp-base-button
              label="運勢を占う"
              design="fill"
              :color-scheme="colorScheme"
              @clicked="clickedSubscFor('unsei')"
            />

          </div>

          <div class="over-content">
            <div class="block-about-fortune2-base__point over-content-inner">
              <div class="title-box"><img class="title" src="/static/img/recommend/lp/touwa/text_hatsukoukai.svg" alt=""></div>
              <div class="title-box"><img class="title" src="/static/img/recommend/lp/touwa/text_cocolonotobira.svg" alt=""></div>
          
              <img class="mainimage" src="/static/img/recommend/lp/touwa/lp_touwa_img4.png" alt="">
              <img class="f_f_title" src="/static/img/recommend/lp/touwa/free_fortune_title3.svg" alt="">

              <subscr-fortune-preview
                :result-data="previewResultList[1]"
                :color-data="colorScheme"
                :lp-id="lpId"
                class="preview-item"
              />
              <p class="subsc-leadtext">属性開抛＆タロットで<br>
                あなたの知りたいこと、<br>
                全て占います<br>
                占いTVで定額占い放題
              </p>

              <ul class="point-ul point-ul--etc">
                <li class="point-li">・次の恋を占う斗弥タロット</li>
                <li class="point-li">・仕事を占う斗弥タロット</li>
                <li class="point-li">・次に起こる出来事を占う斗弥タロット</li>
                <li class="point-li">・相手の気持ちを知る斗弥タロット</li>
                <li class="point-li">・元恋人は私のことを今どう思ってる？</li>
              </ul>
              
              <img class="mainimage" src="/static/img/recommend/lp/touwa/lp_touwa_img5.png" alt="">

              
              <lp-base-button
                label="カードを引く"
                design="fill"
                :color-scheme="colorScheme"
                @clicked="clickedSubscFor('card')"
              />

            </div>
          </div>


          <div v-for="(point, idx) in pointCount(1,2)" :key="`second-${idx}`" class="block-about-fortune2-base__point end-box">
            <div class="talkarea">
              <div class="talkarea__box talkarea__box--left">
                <img :src="point.iconLeft" class="talkarea-icon">
                <p v-html="point.leftWord"></p>
              </div>
              <div class="talkarea__box talkarea__box--right">
                <img :src="point.iconRight" class="talkarea-icon">
                <p v-html="point.rightWord"></p>
              </div>
            </div>
            <p class="caption" v-html="point.caption"></p>
            <div class="title-box"><img class="title--banner" :src="point.pointTitle"></div>
            <p :class="{center : point.isCenter }" class="point-lead" v-html="point.pointLead"></p>
            <img :src="point.mainImage" alt="" class="mainimage">
            <ul v-if="point.pointLists" class="point-ul">
              <li class="point-li" v-for="(item, idx) in point.pointLists" :key="idx" v-html="item"></li>
            </ul>
            <p v-if="point.popText" class="pop-text">{{point.popText}}</p>

            <lp-base-button
              :label="point.buttontext"
              design="fill"
              :color-scheme="colorScheme"
              @clicked="clickedSubscFor(point.eventLabel)"
            />

          </div>
         

          <!--
          <div class="block-about-fortune-base__frame">
            <i></i>
            <div class="inn">
              <iframe src="https://uranaitv.jp/content/569264" width="100%" height="850"></iframe>
            </div>
          </div>
          -->
        </div>
        <!-- lineキャンペーンバナー追加 -->
        <!-- <line-campaign-message class="line-campaign-message--top" :target-info="targetInfo" :color-scheme="colorScheme"/> -->
        <!-- <block-banner
          class="block-banner--top"
          banner-pos="top"
          :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
          :lp-id="this.lpId"
          :campaign="bannerType"
          :target-info="targetInfo"
          :color-scheme="colorScheme"
          :has-caption="true"
        /> -->
        <!-- 占術のこと -->
        <!-- <div class="block-about-fortune-base__box">
          <img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44">
          <h3 class="block-about-fortune-base__method-headline" v-html="targetInfo.fortune.method.headline"></h3>
          <p class="block-about-fortune-base__method-text" v-html="targetInfo.fortune.method.text"></p>
          <div class="block-about-fortune-base__method-sample">
            <img :src="targetInfo.fortune.method.avatar" alt="" class="block-about-fortune-base__method-avator">
            <ul class="block-about-fortune-base__method-sample-list">
              <li v-for="(v, i) in targetInfo.fortune.method.sample" :key="i">
                <img :src="v.icon" alt="">
                <div>
                  <h4>{{ v.label }}</h4>
                  <p>{{ v.text }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="block-about-fortune-base__method-counselor">
            <img class="block-about-fortune-base__method-counselor-image" :src="targetInfo.fortune.method.counselorImage" alt="">
            <p class="block-about-fortune-base__method-advice" v-html="targetInfo.fortune.method.advice"></p>
          </div>
        </div> -->
        <!-- <block-about-counselor3 :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/> -->
      </div>
      <!-- 無料診断 -->
      <!-- <div class="block-about-fortune-base__free">
        <svg viewBox="0 0 375 66" fill="#F9F5ED" class="block-about-fortune-base__free-curve" xmlns="http://www.w3.org/2000/svg">
          <path d="M375 0H0V42C0 42 78.5 65.9488 187.5 65.9488C296.5 65.9488 375 42 375 42V0Z"/>
        </svg>
        <div class="block-about-fortune-base__free-row">
          //<img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44">
          <p class="block-about-fortune-base__free-text">{{ targetInfo.fortune.free.text }}</p>
          <img :src="targetInfo.fortune.free.img" alt="" class="block-about-fortune-base__free-img">
        </div>
        <lp-base-button
          label="試しに無料診断"
          design="primary"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
      </div> -->

      
      
    </div>
   
  </div>
</template>

<script>
import SubscrFortunePreview from '@/utvStore/components/recommend/lp/partials/SubscrFortunePreview'
import LpTitle from '@/utvStore/components/recommend/lp/partials/LpTitle'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import BlockAboutCounselor3 from './BlockAboutCounselor3'

export default {
  name: 'BlockAboutFortune3',
  components: {
    LpTitle,
    LpBaseButton,
    BlockBanner,
    BlockAboutCounselor3,
    SubscrFortunePreview,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    lpId: Number,
    subscUrl: String,
    previewResultList: {
      type: Array,
      default: null,
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    previewColors(){
      return {
        gradStart: this.colorScheme.gradStart,
        gradEnd: this.colorScheme.gradEnd,
        previewBg: '#F9F5ED',
        previewBorder: '#000',
        font: '#32373f',
        head: this.colorScheme.second,
      }
    },
    

  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    clickedSubsc() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-subsc-button`,
        'event_label': 'card',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    clickedSubscFor(eventlabel) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}basicresult-subsc-button`,
        'event_label': eventlabel,
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    pointCount (count_start,count_end){
    	return this.pointData.slice(count_start, count_end)
    },
  },
  data(){
    return {
      pointData:[
        {
          iconLeft:'/static/img/recommend/lp/touwa/icon_touwa.png',
          leftWord:'「舞台に立って何か表現するような仕事が向いていますよ」',
          iconRight:'/static/img/recommend/lp/touwa/icon_woman1.png',
          rightWord:'「！最近、演技のレッスンを始めたんです」<br>本田仁美さん（AKB48）',
          caption:'テレビ東京『どこまで言っていいですか？』<br>7月15日放送回より',
          pointLead:'鑑定の際、常に斗弥の手元にあり、あなたの宿めが綴られていく手帖。覗いてみませんか？',
          isCenter:false,
          pointTitle:'/static/img/recommend/lp/touwa/zokusei_unmei_title.png',
          mainImage:'',
          buttontext:'宿命を知る',
          eventLabel:'techo',
          pointLists:[
            `・あなたは、<strong>このために生まれてきた人</strong>です`,
            `・あなたの<strong>才能が花開く</strong>とき`,
            `・あなたに<strong>約束された成功の果実</strong>`,
            `・<strong>＜人生のめざめ＞</strong>をもたらす出来事`,
            `・「<strong>生まれてきてよかった</strong>」と思える瞬間`,
          ]
        },
        {
          iconLeft:'/static/img/recommend/lp/touwa/icon_touwa.png',
          leftWord:'「恋愛の流れが入っていますよ。出会うのは誰かの紹介。ママさんのお店とか」',
          iconRight:'/static/img/recommend/lp/touwa/icon_man1.png',
          rightWord:'「 ！そういうお店ならよく行きます」<br>じんじんさん（パパラビーズ）',
          caption:'TBS系『占いメガネ』11月27日放送回より',
          pointLead:'あなたのたったひとつの恋を、<br>斗弥が詳細に鑑定します',
          isCenter:true,
          leadPosition:'center',
          pointTitle:'/static/img/recommend/lp/touwa/text_unmeinohito.svg',
          mainImage:'/static/img/recommend/lp/touwa/lp_touwa_img2.png',
          buttontext:'運命の恋を占う',
          eventLabel:'unmei',
        },
        {
          iconLeft:'/static/img/recommend/lp/touwa/icon_touwa.png',
          leftWord:'「5月、決めなきゃいけないような出来事が」',
          iconRight:'/static/img/recommend/lp/touwa/icon_woman2.png',
          rightWord:'「！もう全当たり」<br>藤田ニコルさん',
          caption:'テレビ東京『どこまで言っていいですか？』<br>6月10日放送回より',
          pointTitle:'/static/img/recommend/lp/touwa/text_anatanounsei.svg',
          mainImage:'/static/img/recommend/lp/touwa/lp_touwa_img3.png',
          popText:'＼運勢も528円で占い放題／',
          buttontext:'運勢を知る',
          eventLabel:'unsei',
          pointLists:[
            `・年内なるはやで離婚したい`,
            `・今月告白したいと思ってます`,
            `・復縁希望。相手の状況はどうですか？`,
            `・今年は起業・転身に適した年ですか？`,
            `・今年、転職してお給料を上げたい`,
            `・今年引っ越ししたら運気は上がる？`,
          ]
        },

      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);



.block-about-fortune2-base {
  background-color: #F9F5ED;
  padding: 60px 0 0;
  background: url(/static/img/recommend/lp/touwa/lp_point_bk.png);
  background-repeat-x: no-repeat;
  background-repeat-y: repeat;
  background-size: cover;

  &__box{
    padding-bottom: 60px;
  }

  .top-text{
    text-align: center;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 34px;
    margin: 0;
    margin-bottom: 60px;
  }
  .gold{
    color: #9f895b;
  }
  .gold-line{
    background:linear-gradient(transparent 80%, #9f895b 80%);
  }
  &__inner {
    padding: 0 20px;
  }
  .talkarea__box{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    p{
      margin:0;
    }
  }
  .bold{
    font-weight: bold;
  }
  .center{
    text-align: center;
  }
  .talkarea__box--left{
    .talkarea-icon{
      margin-right: 16px;
    }
  }
  .talkarea__box--right{
    flex-flow: row-reverse;
    .talkarea-icon{
      margin-left: 16px;
    }
  }
  .talkarea-icon{
    width:80px;
    height: 80px;
  }
  .caption{
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    margin: 0;
    margin-bottom: 24px;
  }
  .title-box{
    text-align: center;
  }
  .etc{
    margin:0;
    margin-bottom: 16px;
  }  
  .pop-text{
    text-align: center;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 18px;
  }
  
  &__point{
    background: #fff;
    border: 1px solid #9c8961;
    padding: 20px;
    border-radius: 10px;
    //text-align: center;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      margin-bottom: 16px;
    }
    .f_f_title{
      width:203px;
    }
    .title--banner{
      margin-bottom: 16px;
      width: 100%;
    }
   
    a {
      font-size: 16px;
      text-decoration: underline;
      color: #fda553;
      background: linear-gradient(270deg, #f2d15d 0%, #fda553 51.04%, #ee545e 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      border-bottom: 1px solid #fda553;
    }
  }
  .mainimage{
    width:100%;
    margin-bottom: 16px;
  }
  .point-lead{
    margin:0;
    margin-bottom:16px ;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .point-ul {
    background: #EEF7FF;
    border-radius: 10px;
    padding: 16px 6px;
    margin-bottom: 24px;
    list-style: none;
    &--etc{
      &:after{
        content: 'etc';
        font-size: 14px;
        padding-top: 0px;
        display: block;
      }
      
    }
  }
  .point-li{
    
  }

  .end-box{
    margin-top: 48px;
  }
  .over-content{
    margin: 0 calc(50% - 50vw);
    width: 100vw;
    background: #fff;
    padding: 60px 20px;
  }
  
  

  .baseButton {
    //width: 80%;
    width: 88%;
    max-width: 382px;
    margin: auto;
    /deep/ {
      .baseButton__button--primary {
        background: #6799CB;
        .baseButton__button__label {
          color: #6799CB;
          &::after {
            background-color: #6799CB;
          }
        }
      }
    }
  }
  .subsc-leadtext{
    text-align: center;
    font-size: 18px;
    line-height: 34px;
    color: #303030;
    margin-bottom: 24px;
  }

  .subscr-preview-base {

    background: #fff;
    border: none;
    width: 100%;
    padding: 16px 0px;
  }
  .over-content-inner{
    max-width: 540px;
    margin: auto;
  }
  
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockAboutFortune3.vue